import request from '@/services/interceptor.js'

// A differenza di api.tenant.js (SuperAdmin, cross-tenant su /tenant/{id}), qui
// l'Admin opera sempre e solo sulla propria azienda corrente via /mia-azienda,
// senza mai passare un id.
export const get_mia_azienda = () => {
    return request({ url: '/mia-azienda', method: 'get', loadingBar: true })
}

export const update_mia_azienda = (dati) => {
    return request({ url: '/mia-azienda', method: 'put', data: dati, loadingBar: true })
}

export const upload_logo_azienda = (file) => {
    const formData = new FormData()
    formData.append('file', file)
    return request({
        url: '/mia-azienda/logo',
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' },
        loadingBar: true
    })
}

export const elimina_logo_azienda = () => {
    return request({ url: '/mia-azienda/logo', method: 'delete', loadingBar: true })
}

// Il logo va mostrato in automatico nella sidebar (non su click come gli altri
// allegati), quindi lo si scarica come blob e se ne ricava un object URL locale
// invece di aprirlo/scaricarlo su richiesta dell'utente.
export const get_logo_azienda_blob = () => {
    return request({ url: '/mia-azienda/logo', method: 'get', responseType: 'blob' })
}
